import { Box, RBox, Tor } from './helpers';
import type { MatsProps } from './materials';

/** Cargo box, driving cab + cowl + nose, and the (mostly hidden) cabin interior. */
export function Body({ mats }: MatsProps) {
  return (
    <group>
      {/* Cargo box */}
      <RBox args={[1.72, 1.24, 1.34]} radius={0.08} mat={mats.paint} pos={[-0.8, 1.12, 0]} />
      <Box args={[1.78, 0.045, 1.4]} mat={mats.chromeHi} pos={[-0.8, 0.52, 0]} />
      <Box args={[1.5, 0.1, 0.86]} mat={mats.black} pos={[-0.8, 0.4, 0]} />

      {/* Cab + cowl + nose */}
      <RBox args={[0.96, 0.92, 1.22]} radius={0.17} mat={mats.paint} pos={[0.52, 1.0, 0]} />
      <RBox args={[0.66, 0.6, 1.16]} radius={0.2} mat={mats.paint} pos={[1.02, 0.72, 0]} />
      <RBox args={[0.4, 0.42, 1.02]} radius={0.18} mat={mats.paint} pos={[1.34, 0.6, 0]} />
      <Box args={[0.012, 0.02, 1.1]} mat={mats.gasket} pos={[0.8, 0.9, 0]} />

      {/* Cabin interior */}
      <Box args={[0.9, 0.7, 1.1]} mat={mats.cabinDark} pos={[0.52, 1.06, 0]} />
      <RBox args={[0.9, 0.16, 1.06]} radius={0.05} smoothness={3} mat={mats.black} pos={[0.62, 0.86, 0]} />
      {[0.3, -0.3].map((z) => (
        <RBox key={z} args={[0.26, 0.34, 0.3]} radius={0.06} smoothness={3} mat={mats.seat} pos={[0.4, 0.9, z]} />
      ))}
      <Tor args={[0.11, 0.02, 10, 20]} mat={mats.black} pos={[0.66, 0.92, 0.28]} rot={[0, 0.2, 0.15]} />
    </group>
  );
}
